<template>
    <div
        :class="{
            tiw__handedDevice: true,
            tiw__handedDevice_noGrade: props.deviceTerminated,
        }"
    >
        <div class="tiw__handedDevice__container">
            <Button
                class="tiw__handedDevice__edit"
                type="button"
                variant="unset"
                @click="onEditHandler"
            >
                <EditIcon />
            </Button>
            <figure class="tiw__handedDevice__figure">
                <img
                    class="tiw__handedDevice__image"
                    :src="props.devicePreview"
                    alt="Handed device"
                />
            </figure>

            <div class="tiw__handedDevice__body">
                <p class="tiw__handedDevice__title">
                    {{ useTranslate("tiw__handedDevice__title") }}
                </p>
                <ul v-if="props.deviceChain" class="tiw__handedDevice__device-chain">
                    <li v-for="(chainElement, ind) in props.deviceChain" :key="'chain_' + ind">
                        <span>{{ chainElement }}</span>
                    </li>

                    <li v-if="props.deviceState">
                        {{ props.deviceState }}
                    </li>
                </ul>
                <template v-if="HowYouRateDeviceStore.wasDataUpdatedByPhotoset">
                    <div :class="classes.priceBlock">
                        <span>{{ useTranslate("tiw__handedDevice__condition") }}</span>
                        <b>{{ props.deviceState }}</b>
                    </div>

                    <hr />
                </template>
                <div v-if="props.devicePrice" :class="classes.priceBlock">
                    <span>{{
                        HowYouRateDeviceStore.wasDataUpdatedByPhotoset
                            ? useTranslate("tiw__handedDevice__deviceValuation")
                            : useTranslate("tiw__handedDevice__valuation")
                    }}</span>
                    <b>
                        {{ props.devicePrice }}
                        {{ HowYouRateDeviceStore.registeringDeviceData.currency }}
                    </b>
                </div>
            </div>
        </div>

        <div v-if="props.deviceGrade" class="tiw__handedDevice__current-grade">
            <p class="tiw__title">
                {{ props.deviceGrade.title }}
            </p>
            <p v-if="props.deviceGrade.info" class="tiw__text">
                {{ props.deviceGrade.info }}
            </p>
        </div>
        <!-- Ошибка что Гдейд девайса не определен -->
        <div v-if="props.deviceNoGrade" class="tiw__handedDevice__no-grade">
            <span>
                {{ useTranslate("tiw__handedDevice__unknownGrade") }}
            </span>
        </div>
        <!-- Ошибка что девайс к выкупу не подлежит  -->
        <div v-if="props.deviceTerminated" class="tiw__handedDevice__no-grade">
            <span>
                {{ useTranslate("tiw__handedDevice__deviceTerminated") }}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: "HandedDevice",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [HandledDevice]
 * Плитка сдаваемого устройства
 */

import { useCssModule } from "vue";

import { useAnalyticsEventTiModel } from "@/hooks/useAnalytics/useAnalytics.js";
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter.js";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice.js";
import { useTIWStore } from "@/stores/tiw/tiw.js";
import Button from "@/ui/button/button.vue";
import EditIcon from "@/ui/icons/edit.vue";

import type { I_HandedDevice } from "./handedDevice.types.ts";

const classes = useCssModule();

const props = defineProps<I_HandedDevice>();

const HowYouRateDeviceStore = useHowYouRateDeviceStore();
const TIWStore = useTIWStore();

const onDefaultEditHandler = () => {
    useStoreResetter();
    TIWStore.switchStep("chooseDevice");
    useAnalyticsEventTiModel();
};

const onEditHandler = () => {
    if (props.onEdit) {
        props.onEdit();
    } else {
        onDefaultEditHandler();
    }
};
</script>

<style lang="scss" src="./handedDevice.scss"></style>
<style module>
.priceBlock {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}
</style>
